import { observable, action } from "mobx";
import { Message, MessageType } from "./message";
import { Translation } from "../../i18n";
import { createContext } from "react";
import { ServiceInterface } from "../service.interface";
import { ErrorTokens } from "../api/error.tokens";

export interface MessageShowOptions {
  message: Translation | string;
  type?: MessageType;
  duration?: number;
  values?: { [key: string]: any };
}

export const MessageServiceContext = createContext<MessageService>(null as any);

export class MessageService implements ServiceInterface {
  public context = MessageServiceContext;

  @observable
  public activeMessage?: Message;

  @observable
  public latestMessage?: Message;

  private activeTimeout?: NodeJS.Timeout | number;

  @action
  public show(options: MessageShowOptions) {
    this.clearTimeout();

    const errorToken =
      typeof options.message === "string"
        ? ErrorTokens[options.message]
        : undefined;

    this.activeMessage = Message.create(
      errorToken || options.message,
      options.type,
      options.values
    );
    this.latestMessage = this.activeMessage;
    this.setTimeout(options.duration);
  }

  public showError = (e: any, options?: Partial<MessageShowOptions>) => {
    this.show({
      ...options,
      message: e?.localizedMessage || e?.message || e,
      type: "danger",
    });
  };

  @action
  public catch<T>(
    promise: Promise<T>,
    options: { disableDebug?: boolean } = {}
  ): Promise<T> {
    promise.catch((e) => {
      if (options.disableDebug && __DEV__) return;
      this.showError(e);
    });

    return promise;
  }

  @action
  public dismissActive = () => {
    this.clearTimeout();
    this.activeMessage = undefined;
  };

  private clearTimeout() {
    if (!this.activeTimeout) return;
    clearTimeout(this.activeTimeout as NodeJS.Timeout);
    this.activeTimeout = undefined;
  }

  private setTimeout(duration = 4000) {
    this.activeTimeout = setTimeout(this.dismissActive, duration);
  }
}
